import Editor from "../../Components/common/Editor";
import trans from "./../../../Languages/Languages";
import { useState, useEffect } from "react";
import { Button, Form, Input, message, Card } from "antd";
import API from "../../../API";
import { usePageContext } from "../../../Context/PageContext";

const EnrollmentProcess = () => {
  const [editorHtml, setEditorHtml] = useState("");

  const handleTextEditorChange = (html) => {
    setEditorHtml(html);
  };
  const [loading, setLoading] = useState(true);
  //
  const [enrollmentData, setEnrollmentData] = useState({});
  const [errors, setErrors] = useState({});
  const [toRefreshData, setToRefreshData] = useState(false);
  const [pageData, setPageData] = useState(null);
  const [isRenaming, setIsRenaming] = useState(false);
  const [renameValue, setRenameValue] = useState("");
  const [showContextMenu, setShowContextMenu] = useState(false);
  const [contextMenuPos, setContextMenuPos] = useState({ x: 0, y: 0 });
  const { triggerRefresh } = usePageContext();

  ///////////////////////////////////////////////////////////////////////////////////////////////
  ///                             Use Effect
  ////////////////////////////////////////////////////////////////////////////////////////////////
  useEffect(() => {
    setLoading(true);

    const init = async () => {
      await API.get("/admin/enrollment")
        .then((res) => {
          const { enrol, page } = res.data;
          setPageData(page);
          setRenameValue(page?.title);
          setEditorHtml(enrol?.requirements);
          setEnrollmentData(enrol);
          setErrors({});
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
        });
    };

    init();
  }, [toRefreshData]);


  // Hide context menu on outside click
  useEffect(() => {
    const handleClickOutside = () => {
      setShowContextMenu(false);
    };

    window.addEventListener("click", handleClickOutside);
    return () => window.removeEventListener("click", handleClickOutside);
  }, []);

  const onFinish = (values) => {
    setLoading(true);
    const formData = new FormData();
    formData.append("requirements", editorHtml);
    formData.append("email", values.email);
    formData.append("fax", values.fax);
    formData.append("post_address", values.address);
    formData.append("po_box", values.poBox);
    API.post("/admin/enrollment/update", formData)
      .then((res) => {
        setLoading(false);
        setToRefreshData(!toRefreshData);
        message.success("Updated Successfully", 3);
      })
      .catch((err) => {
        setLoading(false);
        setErrors(err.response.data);
      });
  };

  const handleRenameSubmit = async () => {
    try {
      await API.put(`/admin/pages/slug/${pageData.slug}`, {
        title: renameValue,
      });
      setPageData((prev) => ({
        ...prev,
        title: renameValue,
      }));
      setIsRenaming(false);
      triggerRefresh(); // 🔁 this triggers sidebar reload
    } catch (err) {
      console.error("Rename failed", err);
      message.error("Rename failed");
    }
  };
  return (
    <div className='pages-container'>
      <Card loading={loading} bordered={false}>
        <div className='content-wrapper'>
          <div className='bg-content-container'>
            {/* Title with rename logic */}
            <div style={{ position: "relative" }}>
              <div
                className="fw-600 mb-2"
                onDoubleClick={() => setIsRenaming(true)}
                onContextMenu={(e) => {
                  e.preventDefault();
                  setContextMenuPos({ x: e.clientX, y: e.clientY });
                  setShowContextMenu(true);
                }}
              >
                {isRenaming ? (
                  <input
                    type="text"
                    value={renameValue}
                    autoFocus
                    onChange={(e) => setRenameValue(e.target.value)}
                    onBlur={handleRenameSubmit}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") handleRenameSubmit();
                    }}
                    style={{ padding: "2px 6px", fontSize: "14px" }}
                  />
                ) : (
                  pageData?.title || "Loading..."
                )}
              </div>

              {showContextMenu && (
                <ul
                  style={{
                    position: "fixed",
                    top: contextMenuPos.y,
                    left: contextMenuPos.x,
                    backgroundColor: "white",
                    border: "1px solid #ccc",
                    borderRadius: 4,
                    listStyle: "none",
                    padding: "5px 10px",
                    margin: 0,
                    zIndex: 1000,
                    cursor: "pointer",
                    boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                  }}
                  onClick={() => {
                    setIsRenaming(true);
                    setShowContextMenu(false);
                  }}
                  onMouseLeave={() => setShowContextMenu(false)}
                >
                  <li>{trans.Rename}</li>
                </ul>
              )}
            </div>
            <Editor
              key='enrollment'
              editorHtml={editorHtml}
              setEditorHtml={setEditorHtml}
              handleChange={handleTextEditorChange}
            />
          </div>
          <Form onFinish={onFinish}>
            <div className='bg-content-container'>
              <div className='fw-600 '>{trans.Informationbox}</div>
              <div className='f-12 fw-500'>
                {
                  trans.EnterthecontactdetailsbelowforstudentstosubmitApplication
                }
              </div>
              {/* Email */}
              <div className='accordion-detail ep-email-input'>
                <div className='f-12 fw-500 input-heading '>{trans.Email}</div>
                <Form.Item name='email' initialValue={enrollmentData.email} style={{
                  marginBottom: "4px",
                }}>
                  <Input type='text' />
                </Form.Item>
                {errors?.email && (
                  <span className="text-danger">{errors?.email}</span>
                )}
              </div>

              {/* Fax */}
              <div className='accordion-detail ep-email-fax'>
                <div className='f-12 fw-500 input-heading '>{trans.Fax}</div>
                <Form.Item name='fax' initialValue={enrollmentData.fax}>
                  <Input type='text' />
                </Form.Item>
                {errors?.fax && (
                  <span className="text-danger">{errors?.fax}</span>
                )}
              </div>

              {/* post Address */}
              <div className='accordion-detail ep-post-address-input'>
                <div className='f-12 fw-500 input-heading '>
                  {trans.Postaddress}
                </div>
                <Form.Item
                  name='address'
                  initialValue={enrollmentData.post_address}
                >
                  <Input type='text' />
                </Form.Item>
                {errors?.post_address && (
                  <span className="text-danger">{errors?.post_address}</span>
                )}
              </div>

              {/* PO BOX */}
              <div className='accordion-detail ep-po-input'>
                <div className='f-12 fw-500 input-heading'>{trans.POBox}</div>
                <Form.Item name='poBox' initialValue={enrollmentData.po_box}>
                  <Input type='text' />
                </Form.Item>
                {errors?.po_box && (
                  <span className="text-danger">{errors?.po_box}</span>
                )}
              </div>
            </div>
            {/* save changes */}

            <Button
              className='btn-save-changes'
              type='primary'
              htmlType='submit'
            >
              {trans.Save}
            </Button>
          </Form>
        </div>
      </Card>
    </div>
  );
};

export default EnrollmentProcess;
